export const enum MeasurementTypes {
  Process = "Process measure",
  Outcome = "Outcome measure",
  Balancing = "Balancing measure",
}

export interface MeasurementType {
  changeIdea: string;
  measurmentType: MeasurementTypes;
  name: string;
  dataType: string;
  numerator: string;
  denominator: string;
  numericValue: string;
  frequency: string;
  target: string;
  baseline: string;
}

export interface MeasurementDTO {
  name: string;
  measurement_type: string;
  data_type: string;
  target: number;
  base_line: number;
  frequency: string;
  department_id: number;
  technical_area_id: number;
  id?: number;
}
